import moment from 'moment';
import React, { useState, useEffect } from 'react';

// Pass startDate to count UP (elapsed since start) or endDate to count DOWN (remaining until end).
const LiveTimer = ({ startDate, endDate }: any) => {
    const calculateTimeDifference = () => {
        const anchor = endDate ?? startDate;

        // Guard a missing/invalid anchor (e.g. a pre-seeded lead with null callStartedAt)
        // so we render 00:00 instead of "NaN:NaN".
        if (!anchor || !moment.utc(anchor).isValid()) {
            return '00:00';
        }

        const now = moment.utc(); // Get the current time in UTC
        // Countdown: remaining until endDate. Count-up: elapsed since startDate.
        const duration = endDate ? moment.duration(moment.utc(endDate).diff(now)) : moment.duration(now.diff(moment.utc(startDate)));

        if (duration.asSeconds() <= 0) {
            return '00:00';
        }

        const hours = Math.floor(duration.asHours()); // Get total hours
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        if (hours > 0) {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        } else {
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
    };

    const [timeDifference, setTimeDifference] = useState(calculateTimeDifference());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeDifference(calculateTimeDifference());
        }, 1000);

        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate]);

    return <p>{timeDifference}</p>;
};

export default LiveTimer;
